@if (vm$ | async; as vm) {
  @if (vm.show) {
    <mat-progress-bar
      [mode]="vm.mode"
      [value]="vm.mode === 'determinate' ? vm.progress : 0"
    ></mat-progress-bar>
  }
}
